import React from "react";
import { Switch, Route } from "react-router-dom";
import Index from "../../components/templates/index";
import NewAccount from "../../components/templates/new-account";
import RecoverAccount from "../../components/templates/recover-account";
import ResetPassword from "../../components/templates/reset-password";
import VerifyAccount from "../../components/templates/verify-account";

export default () => {
  return (
    <Switch>
      <Route path="/recover/:email?" component={RecoverAccount} />
      <Route path="/reset/:email/:token" component={ResetPassword} />
      <Route path="/verify-email/:email/:token?" component={VerifyAccount} />
      <Route path="/new" component={NewAccount} />
      <Route path="/" component={Index} />
    </Switch>
  );
};
